import React, { useState } from "react";
import BaseLayout from "layouts/base-layout";
import Category from "components/lexicon-category/category";
import SearchIngredients from "components/search-ingredients";
import RichText from "components/rich-text";
import Image from "components/image";

export { Head } from "components/head";

const Lexicon = ({ pageContext, location }) => {
	const { categories, heroBanner, header, footer, pageSettings } = pageContext;
	const [searchQuery, setSearchQuery] = useState("");

	const handleSearch = (query) => setSearchQuery(query);

	return (
		<BaseLayout
			path={location.pathname}
			header={header}
			footer={footer}
			pageSettings={pageSettings}
		>
			{heroBanner && (
				<div className="w-full relative mb-5 md:mb-14">
					<div className="text-center md:w-1/2 py-5 md:absolute md:top-1/3 md:right-[5%] z-[1]">
						<RichText value={heroBanner?.content} />
					</div>
					<Image className="w-full" image={heroBanner?.image} alt={heroBanner?.image?.alt} />
				</div>
			)}
			<div className="container mx-auto py-5">
				<div className="flex justify-end mb-2 md:mb-10 h-10 px-2">
					<SearchIngredients handleSearch={handleSearch} />
				</div>

				<div className="flex flex-col justify-between md:flex-row px-8">
					{categories.map((category) => (
						<Category key={category.title} data={category} search={searchQuery} />
					))}
				</div>
			</div>
		</BaseLayout>
	);
};

export default Lexicon;
